import { useEffect, useState } from 'react';
import {
	getContentCardsState,
	refreshContentCards,
	subscribeToContentCardsState,
	type ContentCardsState,
} from './contentCardsService';

export function useContentCards(enabled: boolean): ContentCardsState & {
	retry: () => void;
} {
	const [state, setState] = useState(getContentCardsState);

	useEffect(() => {
		if (!enabled) {
			return;
		}

		const unsubscribe = subscribeToContentCardsState(setState);
		void refreshContentCards(false);

		return unsubscribe;
	}, [enabled]);

	return {
		...state,
		retry: () => {
			void refreshContentCards(true);
		},
	};
}

export function useUnreadContentCardCount(enabled: boolean): number {
	const { items } = useContentCards(enabled);
	if (!enabled) {
		return 0;
	}
	return items.filter((item) => !item.isRead).length;
}
